import { MbConstants } from '../mb-constants'

export class UrlUtils {
  static getPath (url?: string): string {
    if (!url) {
      return ''
    }
    return decodeURIComponent(url)?.split(MbConstants.HASH_SYMBOL)?.[0]
  }

  static getFragment (url?: string): string {
    if (!url) {
      return ''
    }
    return decodeURIComponent(url)?.split(MbConstants.HASH_SYMBOL)?.[1]
  }
}
